import React, { Component } from "react";
import PropTypes from "prop-types";
import { Spinner } from "../../components";

class Logout extends Component {
  constructor() {
    super();
    this.state = {
      loggedOut: false
    };
  }

  componentWillMount() {
    this.props.auth.logout();
    this.setState({
      loggedOut: true
    });
    //close live chat
    //window.Intercom('shutdown');
  }

  render() {
    const { loggedOut } = this.state;

    if (loggedOut) {
      return {
        /*<Redirect to="/" />*/
      };
    }

    return <Spinner message="Logging out" />;
  }
}

Logout.propTypes = {
  auth: PropTypes.object.isRequired
};

export default Logout;



// WEBPACK FOOTER //
// ./src/views/logout/Logout.jsx